import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Include helper methods for API calls
import {
  getPayments as getPaymentsApi,
  addNewPayment as addNewPaymentApi,
  addNewPaymentBulk as addNewPaymentBulkApi,
  updatePaymentBulk as updatePaymentBulkApi,
  updatePayment as updatePaymentApi,
  deletePayment as deletePaymentApi,
  getPaymentById as getPaymentByIdApi,
} from "../../helpers/fakebackend_helper";

// Fetch Payments
export const getPayments = createAsyncThunk(
  "payments",
  async (queryParams) => {
  try {
    const response = await getPaymentsApi(queryParams);
    return response;
  } catch (error) {
    toast.error("Failed to fetch payments", { autoClose: 3000 });
    throw error;
  }
});

// Fetch Payment by ID
export const getPaymentById = createAsyncThunk(
  "payments/getPaymentById",
  async (id) => {
    try {
      const response = await getPaymentByIdApi(id); // Call API to get payment by ID
      return response;
    } catch (error) {
      toast.error("Failed to fetch payment by ID", { autoClose: 3000 });
      throw error;
    }
  }
);

// Add New Payment
export const addNewPayment = createAsyncThunk(
  "payments/addNewPayment",
  async (newPayment) => {
    try {
      const response = await addNewPaymentApi(newPayment);
      toast.success("Payment Added Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to add payement", { autoClose: 3000 });
      throw error;
    }
  }
);

export const addNewPaymentBulk = createAsyncThunk(
  "payments/addNewPaymentBulk",
  async (newPayment) => {
    try {
      const response = await addNewPaymentBulkApi(newPayment);
      toast.success("Payments Added Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to add payement", { autoClose: 3000 });
      throw error;
    }
  }
);

// Update Payment
export const updatePayment = createAsyncThunk(
  "payments/updatePayment",
  async (payment) => {
    try {
      const response = await updatePaymentApi(payment);
      toast.success("Payment Updated Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to update payement", { autoClose: 3000 });
      throw error;
    }
  }
);

// Delete Payment
export const deletePayment = createAsyncThunk(
  "payments/deletePayment",
  async (paymentId) => {
    try {
      const response = await deletePaymentApi(paymentId);
      toast.success("Payment Deleted Successfully", { autoClose: 3000 });
      return { paymentId, ...response };
    } catch (error) {
      toast.error("Failed to delete payement", { autoClose: 3000 });
      throw error;
    }
  }
);
